var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;","to":_vm.to},on:{"click":_vm.link}},[_vm._v(_vm._s(_vm.labelName)+" "),(_vm.match)?_c('i',{class:'icon-arrow-'+(_vm.inverseSort?'up':'down')}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }